import type { Doc } from "building-types/doc";
import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import {
  isSystemEntityEligibleEntityHandle,
  isSystemEntityEligibleEntity,
  isSystemEntity,
} from "./docSystemEntityTools";
import type { SystemEntityEligibleEntity } from "./docSystemEntityTypes";
import docGetEntity from "./entity/docGetEntity";

/**
 * System entities are present in every doc. Therefore they never should be duplicated, deleted,
 * renamed, doc ref'd, etc.
 */
export function docEntityIsSystemEntity(doc: Doc, handle: DocEntityHandle): boolean {
  if (!isSystemEntityEligibleEntityHandle(handle)) {
    return false;
  }

  const entity = docGetEntity(doc, handle) as SystemEntityEligibleEntity | null;
  if (!entity || !isSystemEntityEligibleEntity(entity)) {
    return false;
  }

  return isSystemEntity(entity);
}
